/**
 * Created by mh on 2018/9/30.
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import { observer, inject } from 'mobx-react';
import { observable, computed } from 'mobx';
import axios from 'axios';

import Spinner from '../Spinner';

// TODO this is a copy from AssetLocations put in common shared
const BytesToSize = (bytes) => {
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    if (bytes === 0) return '0 Byte';
    const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10);
    return `${Math.round(bytes / (1024 ** i), 2)} ${sizes[i]}`;
};

@observer
class ArtworkReplacementTile extends Component {
    componentDidMount = () => {
        const { artworkUrl } = this.props;
        this.downloadImage(artworkUrl);
    };

    componentWillReceiveProps = (nextProps) => {
        if (nextProps.artworkUrl !== this.props.artworkUrl) {
            const { artworkUrl } = nextProps;
            this.downloadImage(artworkUrl);
        }
    };

    onImgLoad = ({ target }) => {
        // Use the browsers img to decode width of the image
        this.imageHeight = target.naturalHeight;
        this.imageWidth = target.naturalWidth;
    };

    downloadImage = (url) => {
        // Don't await so loading is async
        axios
            .get(url, {
                responseType: 'arraybuffer',
            })
            .then((imageRequest) => {
                // console.log(image);
                if (imageRequest.status === 200) {
                    // We got an image
                    this.imageContentType = imageRequest.headers['content-type'].toLowerCase();
                    this.imageSizeBytes = imageRequest.data.byteLength;
                    const base64Img = Buffer.from(imageRequest.data, 'binary').toString('base64');
                    this.image = `data:${this.imageContentType};base64,${base64Img}`;
                }
            });
    };

    replaceArtwork = () => {
        const {
            existingId,
            artist,
            releaseTitle,
            releaseRef,
            releaseDate,
            source,
            replacementAction,
        } = this.props;
        // dmrn:musicbrainz:coverartarchive:::release/cf184133-7daa-44cb-8309-91023be848dc/cover-art
        // (source, externalRef, artist, album, contentType, image)
        // TODO the data needs to be routed from the API into the UI and back
        replacementAction(
            source,
            releaseRef,
            artist,
            releaseTitle,
            releaseDate,
            this.imageWidth,
            this.imageHeight,
            this.imageContentType,
            this.image,
            existingId,
        );
    };

    @observable
    imageContentType = null;

    @observable
    imageSizeBytes = 0;

    @observable
    image = null;

    @observable
    imageWidth = 0;

    @observable
    imageHeight = 0;

    render = () => {
        const { source, artist, title, releaseTitle, releaseDate } = this.props;

        // if (this.image) {
        return (
            <div className="col-lg-2 col-sm-4 col-6">
                <div className="card">
                    {this.image ? (
                        <img
                            className="card-img-top"
                            src={this.image}
                            alt="Card Artwork"
                            onLoad={this.onImgLoad}
                        />
                    ) : (
                        <Spinner />
                    )}
                    <div className="card-body">
                        <h6 className="card-title">
                            {source === 'deliverdotmedia:existing' ? (
                                ''
                            ) : (
                                <React.Fragment>
                                    {releaseTitle} <small>({releaseDate})</small>
                                </React.Fragment>
                            )}
                        </h6>
                        <p className="card-text">
                            <small>{artist}</small>
                        </p>
                        <p className="card-text">{title}</p>
                        <p className="card-text">
                            {this.imageWidth}x{this.imageHeight} /{' '}
                            {BytesToSize(this.imageSizeBytes)}
                        </p>
                    </div>
                    <div className="card-footer">
                        <button
                            type="button"
                            className="btn btn-primary btn-block"
                            onClick={this.replaceArtwork}
                            disabled={!this.image ? 'disabled' : false}
                        >
                            {source === 'deliverdotmedia:existing' ? (
                                <FormattedMessage
                                    id="Assets.ReplaceArtwork.LinkArtwork"
                                    defaultMessage="Link"
                                />
                            ) : (
                                <FormattedMessage
                                    id="Assets.ReplaceArtwork.ReplaceArtwork"
                                    defaultMessage="Replace"
                                />
                            )}
                        </button>
                    </div>
                </div>
            </div>
        );
        // }
        // return null;
    };
}

ArtworkReplacementTile.propTypes = {
    // auth: PropTypes.object.isRequired,
    existingId: PropTypes.string,
    artworkUrl: PropTypes.string.isRequired,
    artist: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    source: PropTypes.string.isRequired,
    releaseTitle: PropTypes.string,
    releaseDate: PropTypes.string,
    releaseRef: PropTypes.string.isRequired,
    replacementAction: PropTypes.func.isRequired,
};

export default injectIntl(ArtworkReplacementTile);
